var React = require('react');

function AccessApi (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm3.34-23.145l-1.761 1.762v-5.882a1.579 1.579 0 00-3.158 0v5.882l-1.762-1.762a1.574 1.574 0 00-1.116-.463 1.579 1.579 0 00-1.116 2.695l4.457 4.458a1.579 1.579 0 002.232 0l4.457-4.458a1.579 1.579 0 00-2.232-2.232zm4.922 5.221c-.872 0-1.579.707-1.579 1.579v4.031H13.317v-4.031a1.579 1.579 0 10-3.158 0v5.61c0 .872.707 1.579 1.579 1.579h16.524c.872 0 1.578-.707 1.578-1.579v-5.61c0-.872-.706-1.579-1.578-1.579z","fill":"#fff"}));
}

AccessApi.defaultProps = {"fill":"none","viewBox":"0 0 40 40"};

module.exports = AccessApi;

AccessApi.default = AccessApi;
